(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["katalog-instagram-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      if (root.dataset.kigReady) return;
      root.dataset.kigReady = '1';
      var data = root.querySelector('[data-kig-posts]');
      var dialog = root.querySelector('.kig__dialog');
      if (!data || !dialog || typeof dialog.showModal !== 'function') return;
      var posts = JSON.parse(data.textContent || '[]');
      var img = dialog.querySelector('.kig__media-img');
      var play = dialog.querySelector('.kig__play');
      var caption = dialog.querySelector('.kig__panel-caption');
      var date = dialog.querySelector('.kig__panel-date');
      var link = dialog.querySelector('.kig__panel-link');
      var prev = dialog.querySelector('.kig__nav--prev');
      var next = dialog.querySelector('.kig__nav--next');
      var lang = document.documentElement.lang || undefined;
      var current = 0;

      function show(i) {
        var p = posts[i];
        if (!p) return;
        current = i;
        img.src = p.img;
        img.width = p.w;
        img.height = p.h;
        caption.textContent = p.caption || '';
        link.href = p.url;
        play.href = p.url;
        play.hidden = p.type !== 'video';
        var d = p.date ? new Date(p.date) : null;
        date.textContent = d && !isNaN(d) ? d.toLocaleDateString(lang, { day: 'numeric', month: 'long', year: 'numeric' }) : '';
        if (p.date) date.setAttribute('datetime', p.date);
        prev.disabled = i === 0;
        next.disabled = i === posts.length - 1;
      }
      function close() { dialog.close(); }

      root.addEventListener('click', function (e) {
        var a = e.target.closest('[data-kig-index]');
        if (!a || !root.contains(a) || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        show(Number(a.getAttribute('data-kig-index')));
        dialog.showModal();
        document.documentElement.classList.add('kig-lock');
      });
      dialog.addEventListener('click', function (e) {
        var step = e.target.closest('[data-kig-step]');
        if (step) { show(current + Number(step.getAttribute('data-kig-step'))); return; }
        if (e.target.closest('[data-kig-close]') || e.target === dialog) close();
      });
      dialog.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft' && current > 0) show(current - 1);
        if (e.key === 'ArrowRight' && current < posts.length - 1) show(current + 1);
      });
      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('kig-lock');
        var tile = root.querySelector('[data-kig-index="' + current + '"]');
        if (tile && tile.offsetParent) tile.focus({ preventScroll: true });
      });
    }
    function init() { document.querySelectorAll('[data-kig-popup]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
